import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import config from "../includes/ConfigFile";

const SearchPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q");

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query) {
      setLoading(true);

      axios
        .get(`${config.BASE_URL}/api/search?q=${query}`)
        .then((res) => {
          setResults(res.data.data || []);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [query]);
  useEffect(() => {
  if (results.length > 0) {
    console.log("FULL SEARCH RESULTS 👉", results);
    console.table(results);
  }
}, [results]);

  return (
    <div className="container mt-4">
      <h4 className="mb-4">
        Search Results for: <span style={{ color: "#00e6b8" }}>"{query}"</span>
      </h4>

      {/* Loading */}
      {loading && <p>Loading...</p>}

      {/* No Results */}
      {!loading && results.length === 0 && (
        <p style={{ color: "#ccc" }}>No results found 😔</p>
      )}

      <div className="row mt-3">
        {results.map((item) => (
          <div key={item.id} className="col-md-4 mb-4">
            <div
              className="card shadow-sm"
              style={{
                background: "#111",
                color: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                transition: "0.3s",
              }}
            >
              {/* IMAGE CLICK → STORY */}
              <Link to={`/story/${item.id}`}>
                <img
                  src={`${config.BASE_URL}/public/uploads/admin/post/${item.post_image}`}
                  alt={item.post_title}
                  onError={(e) => (e.target.src = "/no-image.png")}
                  style={{
                    height: "250px",
                    width: "100%",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />
              </Link>

              <div className="card-body">
                <h5 style={{ fontWeight: "600" }}>
                  {item.post_title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#bbb",
                    height: "60px",
                    overflow: "hidden",
                  }}
                >
                  {item.post_short_description}
                </p>

                <small style={{ color: "#00e6b8" }}>
                  By {item.writer_name}
                </small>

                {/* BUTTON */}
                <div className="mt-3">
                  {item.first_chapter ? (
                    <Link
                      to={`/chapter/${item.first_chapter}/${item.id}`}
                      className="btn btn-success btn-sm"
                      style={{ width: "100%" }}
                    >
                      📖 Read Now
                    </Link>
                  ) : (
                    <button
                      className="btn btn-secondary btn-sm"
                      style={{ width: "100%" }}
                      disabled
                    >
                      No Chapter Available
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 🔥 Hover Effect */}
      <style>
        {`
          .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0,0,0,0.5);
          }
        `}
      </style>
    </div>
  );
};

export default SearchPage;